<div fxLayout="column"
     fxLayoutAlign="center center"
     fxLayoutGap="16px"
     class="loading-screen">
    <mat-spinner class="circle"
                 color="primary"></mat-spinner>
    <div>Loading</div>
</div>
@if (!loading) {
<app-custom-policy class="display-none"
                   [b2cURLs]="b2cURLs"
                   [freshDeskUrl]="freshDeskUrl"
                   [signIn]="true"
                   [theme]="theme"></app-custom-policy>
}
